export abstract class ProductSearchLocal {
    public abstract getRecentSearches(): string[];
    public abstract addRecentSearch(query: string): void;
    public abstract deleteRecentSearch(index: number): void;
}